import { z } from "zod";
import { customFieldTypeSchema } from "./customField.js";
const contactPublicApiSchema = z.object({
  id: z.string(),
  account_id: z.string().nullable(),
  email: z.string().nullable(),
  phone_number: z.string().nullable(),
  ext_id: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  custom_fields: z.array(
    z.object({
      key: z.string(),
      value: z.union([z.string(), z.number(), z.boolean(), z.null()]),
      type: customFieldTypeSchema,
      display_name: z.string()
    })
  ),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable()
});
export {
  contactPublicApiSchema
};
//# sourceMappingURL=contactPublicApi.js.map
